<template>
  <div class="bodycontent">
    <div class="page_title">
      新增
    </div>
    <div class="page_form">
      <el-form :model="form" size="small" label-width="120px">
        <el-form-item label="活动名称：">
          <el-input v-model="form.text" style="width:310px"></el-input>
        </el-form-item>
        <el-form-item label="参与对象：">
          <el-radio-group v-model="form.all">
            <el-radio label="1">全部会员</el-radio>
            <el-radio label="0">部分会员</el-radio>
            <el-radio label="2">会员标签</el-radio>
            <el-radio label="3">会员等级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员：" v-if="form.all == 0">
          {{ selectUserName }}
          <el-button size="small" @click="showSelecterUser = true">选择</el-button>
        </el-form-item>
        <el-form-item label="参与对象：" v-if="form.all == 2">
          <el-select v-model="form.tag_id" placeholder="请选择会员标签" size="small">
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参与等级：" v-if="form.all == 3">
          <!-- <el-select
            v-model="form.level_id"
            placeholder="请选择会员等级"
            size="small"
          >
            <el-option
              v-for="item in level_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
          <el-cascader v-model="form.level_id" :options="level_options" :props="{
            expandTrigger: 'hover',
            label: 'name',
            children: 'lists',
            value: 'id',
            emitPath: false
          }">
          </el-cascader>
        </el-form-item>
        <el-form-item label="活动奖品：">
          <el-row style="padding-bottom: 8px">
            送积分：<el-input class="wdth100" v-model="form.point"></el-input>
          </el-row>
        </el-form-item>
        <el-form-item label="群发内容">
          <el-col :span="10">
            <el-input type="textarea" v-model="form.remark" :rows="12" maxlength="150" show-word-limit
              placeholder="例如 ：恭喜您获得本店赠送的100积分..."></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="save()">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div class="save_button">
    </div> -->
    <!-- 會員 -->
    <!-- 选择用户弹窗 -->
    <el-dialog :visible.sync="showSelecterUser" @close="showSelecterUser = false" width="860px">
      <selectCommodity @close="showSelecterUser = false" @getCommod="getCommodUser" :sList="sUserList" :jude="4"
        :menuName="'会员'"></selectCommodity>
    </el-dialog>
    <!-- 优惠券弹窗 -->
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false" width="800px">
      <newSelectCommodityNum @close="showSelecter = false" @getCommod="getCommod" :sList="sList" :jude="2">
      </newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import { levelGroupSelect } from "@/api/vip";
import { allTag, send_point } from "@/api/market";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    newSelectCommodityNum,
    selectCommodity
  },
  data() {
    return {
      type: [],
      form: {
        text: "", //活动名称
        all: "1", //默认全部会员，暂无选择
        tag_id: "", //会员标签
        level_id: "", //会员等级
        point: '', //参数point 积分 优惠券coupon
        remark: ""
      },
      options: [], //标签
      level_options: [], //会员等级
      sUserList: [], //已选择用户
      selectUserName: "", //选择的用户名称
      showSelecterUser: false,
      showSelecter: false,
      sList: [],
      point: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      allTag(data).then(res => {
        console.log("allMermberTag", res);
        this.options = res.data;
      });
      levelGroupSelect(data).then(res => {
        if (res.code == 200) {
          this.level_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取会员等级列表失败，请刷新重试"
          // })
        }
      });
    },
    getCommodUser(data) {
      console.log("用户id", data);
      this.sUserList = data;
      if (data.length > 5) {
        this.selectUserName =
          data[0].name +
          "," +
          data[1].name +
          "," +
          data[2].name +
          "," +
          data[3].name +
          "," +
          data[4].name +
          "等" +
          data.length +
          "位用户";
      } else {
        this.selectUserName =
          data.map(n => n.name).join(",") + " 共" + data.length + "位用户";
      }
      this.showSelecterUser = false;
    },
    //选择优惠券
    getCommod(data) {
      console.log("子组件传递数据", data);
      // let arrCountId = [];
      // data.forEach(item => {
      //   if (item.choseNum) {
      //     for (var n = 0; n < Number(item.choseNum); n++) {
      //       arrCountId.push(item.id);
      //     }
      //   }
      // });
      this.sList = data;

      // this.form.reward.coupon = arrCountId.join(",");
      // this.sList = data;
      this.showSelecter = false;
      // console.log("点击", this.form.reward.coupon, this.sList);
    },
    //删除选择的优惠券
    delTagItem(x) {
      console.log(x);
      this.sList.splice(x, 1);

      console.log("删除", this.form.reward.coupon, this.sList);
    },
    selectCoupon() {
      console.log("选择优惠券");
      this.sList = this.sList;
      this.showSelecter = true;
    },
    save() {
      var data = this.form;
      data.token = this.token;
      data.app_id = this.app_id;
      //参与对象
      if (this.form.all == 0) {
        // 用户id
        data.uid = this.sUserList.map(item => item.id).join(",");
        this.form.tag_id = "";
      } else if (this.form.all == 2) {
        data.tag_id = this.form.tag_id;
      } else if (this.form.all == 3) {
        data.level_id = this.form.level_id;
      }
      // if (this.type.length) {
        // if (this.type.includes("1")) {
          
        // } else {
        //   delete this.form.reward.point;
        // }
        // if (this.type.includes("2")) {
        //   if (!this.sList.length) {
        //     this.$message.warning("请选择要赠送的优惠券！！");
        //     return;
        //   } else {
        //     let arrCountId = [];
        //     this.sList.forEach(item => {
        //       if (item.choseNum) {
        //         for (var n = 0; n < Number(item.choseNum); n++) {
        //           arrCountId.push(item.id);
        //         }
        //       }
        //     });
        //     this.form.reward.coupon = arrCountId.join(",");
        //   }
        // } else {
        //   delete this.form.reward.coupon;
        // }
      // } else {
        // this.$message.warning("请选择要赠送的内容！！");
        // return;
      // }
      console.log("提交数据", data);
      // return false;
      this.$confirm("确定要发送群发服务通知吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          send_point(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg
              });
              // this.$router.push("sendPoint");
              this.$router.go(-1)
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消开启"
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;

  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }

  .page_form {
    padding-top: 30px;

    .input_box {
      width: 150px;
      margin-right: 10px;
    }

    .input_box_small {
      width: 50px;
    }

    .form_info_text {
      color: #aaa;
    }
  }

  // 输入框
  .wdth100 {
    width: 100px;
  }

  .save_button {
    margin-top: 25px;
    padding-left: 100px;
    margin-bottom: 50px;
  }
}
</style>
